import { Modal } from 'antd';
import styled, { css } from 'styled-components';
import { NewStyledSelect, StyledSelect } from 'components/new-ui/composed/formSelect/styles';

export const SModalHeader = styled.div`
    position: sticky;
    position: -webkit-sticky; /* For Safari */
    top: 0;
    z-index: 2;
    background-color: white;
    padding-top: 1rem;
`;

export const SModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 8px;
    }
`;

export const SFiltersWrapper = styled.div`
    display: flex;
    gap: 1rem;
    margin-bottom: 24px;
`;

export const SFiltersRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
`;

const filterSelectSize = css`
    width: 240px;
    height: 32px;
`;

export const SFilterSelect = styled(NewStyledSelect)`
    ${filterSelectSize}
`;

export const SLegacyFilterSelect = styled(StyledSelect)`
    ${filterSelectSize}
`;
